module.exports = {
  messages: {
    CN: {
      LogIn: "登录",
      SigninwithGoogle: "使用 Google 登录",
      SigninwithLinkedIn: "使用 LinkedIn 登录",
      EntertheFuture: "进入未来最智能的领英自动化工具",
      Dataisloading: "数据正在加载中",
      StartTrial: "开始免费试用",
      try10DaysFree:
        "享受完整的10天免费试用，无需信用卡。先体验，满意后再付款！",
      loadingSpace: "正在加载你的工作空间",
      Afterlogging:
        "进入系统后，点击campaign下的创建按钮，创建你的第一个campaign",
      Whencreating:
        "创建第一个campaign时需要绑定您的LinkedIn账号，请注意：不要绑定全新账号，否则受到LinkedIn风控限制，无法执行任务",
      Youcancreate:
        " 一个LinkedIn下可以创建多个campaign，但是只能有一个在运行状态",
      Settingsearch:
        "搜索条件设置很关键，如果要从当前好友中聊，记得勾选上1ST，想要从全网找客户，则记得勾选2ND和3RD",
      Themore: "搜索条件设置的用户越精准，最终转化率会越高",
      Enteras:
        "请尽可能全面的录入公司，产品，案例，竞品等资料，资料越多，机器人沟通越精准，最后的转化率会越高",
      ForLinkedIn:
        "为了LinkedIn的账号安全，普通账号每日添加好友数量尽量不超过20个，navigator账号每日添加好友数量尽量不超过35个",
      Loginfailed: "登录失败",
      Errorcode: "错误代码",
      Youcantry: "你可以尝试以下方法",
      Logagain: "重新登录",
      Emailus: "联系我们",
      problem: "如果问题持续存在，请联系技术支持",
      authorization: "您已经取消了授权登录，请给予授权",
      SigninwithFacebook: "使用 Facebook 登录",
      SignupwithGoogle: "使用 Google 注册",
      SignupwithLinkedIn: "使用 LinkedIn 注册",
      SignupwithFacebook: "使用 Facebook 注册",
      loginBtnHoverTip:
        "点击此处快速注册账号，无需绑定信用卡，享受 10 天免费试用",
      loginTip: "已经有账号？",
      loginTipBtn: "点击这里",
      SignUpTitle: "欢迎回来!",
      SignUpSubTitle: "继续使用 strategybrain 创造更多价值",
      Email: "邮箱",
      Password: "密码",
      useEmail: "或使用邮箱继续",
      passwordDes: "*密码至少包含8位字符，且必须包含大小写，数字和特殊字符",
      createAaccount: "创建账号",
      rightEmail: "请输入有效的邮箱地址",
      charactersDes: "密码至少包含8位字符",
      uppercaseCharacter: "至少需要包含一个大写字母",
      lowercaseCharacter: "至少需要包含一个小写字母",
      digitRequired: "至少需要包含一个数字",
      specialCharacter: "至少需要包含一个特殊字符",
      verificationCode: "请输入验证码",
      digitVerification: "一个6位数的验证码已经发送至邮箱xxxxx",
      Submit: "提交",
      Resend: "重新发送",
      ForgotPassword: "忘记密码？",
      LOGIN: "登录",
      tryAgain: "邮箱或密码不正确，请重试",
      PasswordReset: "重置密码",
      resetPwdDes: "重置密码的链接已经发送至您输入的邮箱中",
      ResetInstructions: "发送重置链接",
      ReturntoLogIn: "返回登录",
      Success: "发送成功",
      haveSentEmail:
        "我们已经向您的邮箱中发送了重置密码链接，如果未收到，请检查是否在垃圾文件中。",
      resetYourPwd: "重置密码",
      InputNewPwd: "请输入您的新密码",
      newPwd: "新密码",
      confirmNewPwd: "确认新密码",
      resetPwd: "重置密码",
      notMatch: "两次输入密码不一致",
      invalidCode: "无效的验证码",
      humanValid: "请先完成人机校验",
      mobileTips: "我们的AI助手仅限在PC端访问，移动端访问可能会导致显示问题。",
    },

    US: {
      LogIn: "Log In",
      SigninwithGoogle: "Sign in with Google",
      SigninwithLinkedIn: "Sign in with LinkedIn",
      EntertheFuture:
        "Please log in directly to test all features for free without needing to link a credit card.",
      Dataisloading: "Data is loading",
      StartTrial: "Start your free trial",
      try10DaysFree:
        "Enjoy a full 10-day trial with no credit card required. Try it first, pay only if satisfied.",
      loadingSpace: "Loading your workspace",
      Afterlogging:
        "After logging in, click the “Create” button under “Campaign” to create your first campaign.",
      Whencreating:
        "When creating your first campaign, you need to link your LinkedIn account. Note: Do not link a brand-new account, as it may trigger LinkedIn’s risk control restrictions, preventing tasks from being executed.",
      Youcancreate:
        " You can create multiple campaigns under one LinkedIn account, but only one can be active at a time.",
      Settingsearch:
        "Setting search criteria is crucial. If you want to connect with current friends, check “1ST.” To find clients across the network, check “2ND” and “3RD.”",
      Themore:
        "The more precise the search criteria, the higher the final conversion rate.",
      Enteras:
        "Enter as much information as possible about your company, products, cases, and competitors. The more data you provide, the more accurate the bot’s communication will be, and the higher the conversion rate.",
      ForLinkedIn:
        "For LinkedIn account safety, limit daily friend requests to 20 for regular accounts and 35 for Navigator accounts.",
      Loginfailed: "Login failed",
      Errorcode: "Error code",
      Youcantry: "You can try the following methods:",
      Logagain: "Log in again",
      Emailus: "Contact us",
      problem: "If the problem persists, please contact technical support.",
      authorization:
        "You have canceled the authorization login. Please grant authorization.",
      SigninwithFacebook: "Sign in with facebook",
      SignupwithGoogle: " Sign up with Google",
      SignupwithLinkedIn: "Sign up with LinkedIn",
      SignupwithFacebook: "Sign up with facebook",
      loginBtnHoverTip:
        "Click here to quickly register an account, no credit card required, and enjoy a 10-day free trial.",
      loginTip: "Already have an account? ",
      loginTipBtn: "click here",
      SignUpTitle: "Welcome back!",
      SignUpSubTitle: "Continue using StrategyBrain to create more value.",
      Email: "Email",
      Password: "Password",
      useEmail: "or continue with email ",
      passwordDes:
        "*Password must be at least 8 characters, including uppercase, lowercase, numbers, and special characters.",
      createAaccount: "Create an account",
      rightEmail: "*Please enter a valid email address.",
      charactersDes: "Password must be at least 8 characters.",
      uppercaseCharacter: "At least one uppercase character is required.",
      lowercaseCharacter: "At least one lowercase character is required.",
      digitRequired: "At least one digit is required.",
      specialCharacter: "At least one special character is required.",
      verificationCode: "Please enter the verification code",
      digitVerification:
        "A 6-digit verification code has been sent to your email xxxxx",
      Submit: "Submit",
      Resend: "Resend",
      ForgotPassword: "Forgot your password?",
      LOGIN: "LOG IN",
      tryAgain: "Incorrect email or password. Please try again.",
      PasswordReset: "Password Reset",
      resetPwdDes:
        "Please enter your email address to receive instructions on how to reset your password.",
      ResetInstructions: "Send Reset Instructions",
      ReturntoLogIn: "Return to Log In",
      Success: "Success！",
      haveSentEmail:
        "We have sent you an email with password reset instructions.If the email doesn't show up soon, check your spam folder.",
      resetYourPwd: "Reset your password",
      InputNewPwd: "Please, enter your new password",
      newPwd: "New Password",
      confirmNewPwd: "Confirm New Password",
      resetPwd: "Reset Password",
      notMatch: "Passwords do not match",
      invalidCode: "Invalid verification code",
      humanValid: "Please complete the human verification first",
      mobileTips: `*Our AI agent is only accessible on the PC. Mobile access may
              cause display issues. `,
    },
    AR: {
      LogIn: "تسجيل الدخول",
      SigninwithGoogle: "تسجيل الدخول باستخدام جوجل",
      SigninwithLinkedIn: "تسجيل الدخول باستخدام لينكدإن",
      EntertheFuture: "ادخل إلى مستقبل أتمتة لينكد إن الذكية",
      Dataisloading: "يتم تحميل البيانات",
      StartTrial: "ابدأ التجربة المجانية",
      try10DaysFree:
        "استمتع بفترة تجربة كاملة لمدة 10 أيام بدون الحاجة إلى بطاقة ائتمان. جرّب أولاً وادفع فقط إذا كنت راضيًا!",
      loadingSpace: "جاري تحميل مساحة العمل الخاصة بك",
      Afterlogging:
        "بعد تسجيل الدخول، انقر على زر “إنشاء” تحت قسم الحملات لإنشاء أول حملة خاصة بك",
      Whencreating:
        "عند إنشاء الحملة الأولى، يجب ربط حساب LinkedIn الخاص بك. ملاحظة: لا تقم بربط حساب جديد تمامًا لتجنب قيود LinkedIn التي قد تمنع تنفيذ المهام",
      Youcancreate:
        " يمكن إنشاء عدة حملات ضمن حساب LinkedIn واحد، ولكن يمكن تشغيل حملة واحدة فقط في نفس الوقت",
      Settingsearch: `إعداد شروط البحث أمر مهم جدًا: إذا كنت ترغب في التحدث مع الأصدقاء الحاليين، تأكد من اختيار “1ST”، وإذا كنت تريد البحث عن العملاء على مستوى الشبكة، اختر “2ND” و”3RD”`,
      Themore: "كلما كانت شروط البحث أكثر دقة، زادت نسبة التحويل النهائية",
      Enteras:
        "أدخل أكبر قدر ممكن من المعلومات عن الشركة، المنتج، الحالات، والمنافسين؛ فكلما كانت البيانات أكثر شمولاً، أصبح التواصل الآلي أكثر دقة وزادت نسبة التحويل النهائية",
      ForLinkedIn:
        "أدخل أكبر قدر ممكن من المعلومات عن الشركة، المنتج، الحالات، والمنافسين؛ فكلما كانت البيانات أكثر شمولاً، أصبح التواصل الآلي أكثر دقة وزادت نسبة التحويل النهائية",
      Loginfailed: "فشل تسجيل الدخول",
      Errorcode: "رمز الخطأ",
      Youcantry: "يمكنك تجربة التالي",
      Logagain: "تسجيل الدخول مرة أخرى",
      Emailus: "تواصل معنا",
      problem: "إذا استمرت المشكلة، يرجى التواصل مع الدعم الفني",
      authorization: "لقد ألغيت تسجيل الدخول بالتفويض. الرجاء منح التفويض.",
      SigninwithFacebook: "تسجيل الدخول باستخدام فيسبوك",
      SignupwithGoogle: "سجّل باستخدام جوجل",
      SignupwithLinkedIn: "سجّل باستخدام لينكدإن",
      SignupwithFacebook: "سجّل باستخدام فيسبوك",
      loginBtnHoverTip:
        "اضغط هنا للتسجيل بسرعة، دون الحاجة إلى بطاقة ائتمان، وتمتع بتجربة مجانية لمدة 10 أيام",
      loginTip: "هل لديك حساب بالفعل؟",
      loginTipBtn: "اضغط هنا",
      SignUpTitle: "مرحبًا بعودتك",
      SignUpSubTitle: "استمر في استخدام strategybrain لخلق المزيد من القيمة",
      Email: "إيميل",
      Password: "كلمة المرور",
      useEmail: "أو المتابعة باستخدام الإيميل",
      passwordDes:
        "*يجب أن تتكون كلمة المرور من 8 أحرف على الأقل، وتشمل أحرفًا كبيرة وصغيرة وأرقامًا ورموزًا خاصة.",
      createAaccount: "إنشاء حساب",
      rightEmail: "*الرجاء إدخال عنوان إيميل صالح.",
      charactersDes: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
      uppercaseCharacter: "يجب أن تحتوي على حرف كبير واحد على الأقل.",
      lowercaseCharacter: "يجب أن تحتوي على حرف صغير واحد على الأقل.",
      digitRequired: "يجب أن تحتوي على رقم واحد على الأقل.",
      specialCharacter: "يجب أن تحتوي على رمز خاص واحد على الأقل.",
      verificationCode: "الرجاء إدخال رمز التحقق",
      digitVerification: "تم إرسال رمز تحقق مكون من 6 أرقام إلى إيميلك xxxxx",
      Submit: "إرسال",
      Resend: "إعادة الإرسال",
      ForgotPassword: "نسيت كلمة المرور؟",
      LOGIN: "تسجيل الدخول",
      tryAgain:
        "بريد إلكتروني أو كلمة مرور غير صحيحة. الرجاء المحاولة مرة أخرى.",
      PasswordReset: "إعادة تعيين كلمة المرور",
      resetPwdDes:
        "الرجاء إدخال عنوان بريدك الإلكتروني لتلقي تعليمات حول كيفية إعادة تعيين كلمة المرور.",
      ResetInstructions: "إرسال تعليمات إعادة التعيين",
      ReturntoLogIn: "العودة إلى تسجيل الدخول",
      Success: "تم بنجاح!",
      haveSentEmail: `"لقد أرسلنا إليك بريدًا إلكترونيًا يحتوي على تعليمات إعادة تعيين كلمة المرور.
إذا لم يظهر البريد قريبًا، تحقق من مجلد الرسائل غير المرغوب فيها."`,
      resetYourPwd: "إعادة تعيين كلمة المرور",
      InputNewPwd: "الرجاء إدخال كلمة المرور الجديدة",
      newPwd: "كلمة المرور الجديدة",
      confirmNewPwd: "تأكيد كلمة المرور الجديدة",
      resetPwd: "إعادة تعيين كلمة المرور",
      notMatch: "كلمات المرور غير متطابقة",
      invalidCode: "رمز التحقق غير صالح",
      humanValid: "يرجى إتمام التحقق البشري أولاً",
      mobileTips:
        "لا يمكن الوصول إلى مساعد الذكاء الاصطناعي الخاص بنا إلا عبر جهاز الكمبيوتر، فقد يتسبب الوصول عبر الهاتف المحمول في مشاكل في العرض.",
    },
  },
};
